import { render, staticRenderFns } from "./personal-information-controller.vue?vue&type=template&id=608aacec&"
import script from "./personal-information-controller.vue?vue&type=script&lang=js&"
export * from "./personal-information-controller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports